import { Map as iMap, fromJS } from 'immutable';
import * as constants from './user-constants';
import docCookie from '../../utils/docCookie';
import R, {
  subtract,
  __,
  dec,
  append,
  path,
  update,
} from 'ramda';

const initialState = iMap({
  user: {
    type: undefined,
    userID: undefined,
  },
  company: {
    companySlugName: undefined,
    companyName: undefined,
    productType: undefined,
    phone: undefined,
    profileImageUrl: undefined,
    address: {},
    contactInformation: {},
    description: undefined,
    websiteUrl: undefined,
    companyTypes: [],
    countriesServed: [],
    segments: [],
    currency: '',
    taxInclusion: '',
    taxType: '',
  },
  locAccess: [],
  billingPlan: undefined,
  freeContractsUsedIds: [],
  upgradeSource: 'billingLink',
  firstName: undefined,
  lastName: undefined,
  userCountry: undefined,
  onBoardingStatus: undefined,
  isAnAdmin: false,
  isMarketingReady: false,
  pfSearches: 0,
  freeContractsLeft: 5,
  hasViewedContract: false,
  // notifications
  updatingNotification: false,
});

export function user(state = initialState, action) {
  switch (action.type) {
    case 'ADD_LOCATION':
      return state.update('locAccess', locAccess => [
        ...locAccess,
        {
          locId: action.payload.locationId,
          admin: ['read', 'write'],
          contracting: ['read', 'write'],
          teams: ['admin', 'contracting'],
          property_name: action.payload.locationName,
        },
      ]);
    case constants.UPDATE_USER_PROP:
      return state.merge(iMap(action.payload));
    case constants.EDIT_NOTIFICATION_STARTING:
      return state.set('updatingNotification', true);
    case constants.EDIT_NOTIFICATION_FINISHED:
      return state.set('updatingNotification', false)
                  .set('notifications', action.payload.notifications);
    case constants.EDIT_NOTIFICATION_FAILED:
      return state.set('updatingNotification', false);
    case '[user]UPDATE_USER_LOC_ACCESS_WHEN_NEW_LOC_CREATED':
      return state.update('locAccess', locAccess => {
        const currentLocIds = locAccess.map(R.prop('locId'));
        const newIds = action.payload.filter(id => !R.contains(id, currentLocIds));
        return R.concat(locAccess, newIds.map(id => ({ locId: id, admin: ['read', 'write'], contracting: ['read', 'write'], teams: ['admin', 'contracting'] })));
      });
    case 'ADD_CREDIT_CARD':
      return state.setIn(['company', 'authorizeNet'], !state.getIn(['company', 'authorizeNet']));
    case 'UPDATE_ADD_RATES_FIELD':
      if (['currency', 'taxInclusion', 'taxType'].indexOf(action.payload.fieldName) === -1) return state;
      return state.update('company', company => company.merge(fromJS({ [action.payload.fieldName]: action.payload.value })));
    case 'SET_MARKET_READINESS_FOR_USER_STORE':
      if (!state.get('isMarketingReady')) {
        return state.merge({ 'isMarketingReady': true });
      }
      return state;
    case 'LOG_OUT':
    case 'CLEAR_STORES':
      if (action.payload && action.payload.isForAdmin) return state.set('authToken', action.payload.authToken);
      return initialState;
    case 'PROFILE_IMAGE_CHANGED':
      return state.setIn(['company', 'profileImageUrl'], action.payload);
    case 'USER_STORE_PLAN_UPDATE':
      return state.set('billingPlan', action.payload.plan).setIn(['company', 'plan'], action.payload.plan);
    case 'ONBOARDING_COMPLETE':
      return state.set('onBoardingStatus', 'complete');
    case 'UPDATE_UPGRADE_SOURCE':
      return state.set('upgradeSource', action.payload);
    case 'GET_COMPANY':
      return state.set('billingPlan', action.payload.plan).set('company', action.payload);
    case 'GET_USER':
      const payload = action.user || {};
      return state.merge(iMap(payload))
                  .set('billingPlan', payload.company.plan)
                  .set('user', iMap(payload.user))
                  .set('company', iMap(payload.company))
                  .set('isAnAdmin', payload.isAnAdmin || docCookie.getItem('isAnAdmin') === 'true');
    case 'ADD_SEARCH_COUNT':
      const pfSearches = state.get('pfSearches') + 1;
      return state.set('pfSearches', pfSearches);
    case 'UPDATE_SEARCH_COUNT_DB':
      return state.set('pfSearches', 0);
    case 'USED_AS_FREE_BY_CONTRACTOR':
      return state.update('freeContractsLeft', dec)
                  .update('freeContractsUsedIds', append(action.payload.contractId));
    case 'CONTRACT_DRAFT_PUSHLISHED':
      return state.update('freeContractsLeft', subtract(__, action.payload.freeContractsToDecrement));
    case 'DOWNLOAD_CONTRACT_PDF_FOR_SHELL':
      return state.set('hasViewedContract', true);
    case 'UPDATE_PROFILE_PROP':
      const onBoardingStatus = path(['payload', 'onBoardingStatus'], action);
      if (onBoardingStatus) return state.set('onBoardingStatus', onBoardingStatus);
      return state;
    case '{admin} toggleTCVerified_SUCCESS':
      return state.set('company', {
        ...state.get('company'),
        tourConnectVerified: action.payload.newStatus,
      });
    case 'updateUIpreferences_SUCCESS':
      return state.setIn(['user', 'UIpreferences'], action.args[0]);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/user/user-reducer.js